import { defineMessages } from '@cookbook/solid-intl'

export const messages = {
    buttonBack: defineMessages({
        defaultMessage: 'Back',
        id: 'Shared.button.back',
    }),
    buttonCancel: defineMessages({
        defaultMessage: 'Cancel',
        id: 'Shared.button.cancel',
    }),
    buttonClose: defineMessages({
        defaultMessage: 'Close',
        id: 'Shared.button.close',
    }),
    buttonConfirm: defineMessages({
        defaultMessage: 'Confirm',
        id: 'Shared.button.confirm',
    }),
    buttonContinue: defineMessages({
        defaultMessage: 'Continue',
        id: 'Shared.button.continue',
    }),
    buttonDelete: defineMessages({
        defaultMessage: 'Delete',
        id: 'Shared.button.delete',
    }),
    buttonEdit: defineMessages({
        defaultMessage: 'Edit',
        id: 'Shared.button.edit',
    }),
    buttonNext: defineMessages({
        defaultMessage: 'Next',
        id: 'Shared.button.next',
    }),
    buttonNo: defineMessages({
        defaultMessage: 'No',
        id: 'Shared.button.no',
    }),
    buttonOkay: defineMessages({
        defaultMessage: 'Okay',
        id: 'Shared.button.okay',
    }),
    // Common buttons
    buttonSave: defineMessages({
        defaultMessage: 'Save',
        id: 'Shared.button.save',
    }),
    buttonSubmit: defineMessages({
        defaultMessage: 'Submit',
        id: 'Shared.button.submit',
    }),
    buttonYes: defineMessages({
        defaultMessage: 'Yes',
        id: 'Shared.button.yes',
    }),
    defaultDocumentDescription: defineMessages({
        defaultMessage: 'Discover and host unique stays with Lodgr, the fresh alternative to Airbnb or VRBO with lower fees.',
        id: 'Shared.defaultDocumentDescription',
    }),
    defaultDocumentTitle: defineMessages({
        defaultMessage: 'Lodgr | Canada\u2019s Affordable Short Term Rental Platform',
        id: 'Shared.defaultDocumentTitle',
    }),
    labelError: defineMessages({
        defaultMessage: 'Error',
        id: 'Shared.label.error',
    }),
    // Common labels
    labelLoading: defineMessages({
        defaultMessage: 'Loading...',
        id: 'Shared.label.loading',
    }),
    labelSuccess: defineMessages({
        defaultMessage: 'Success',
        id: 'Shared.label.success',
    }),
}

